import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { userQueryKeys } from "@/user/data/userQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import {
  EntityFlagsResponse,
  UpdateEntityFlagsBody,
} from "@reflag/shared/flagAPI";

export function useUpdateUserFlagAccessMutation(userId?: string) {
  const { appId, envId } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    EntityFlagsResponse,
    AxiosError<ErrorResponse>,
    UpdateEntityFlagsBody
  >({
    mutationFn: (variables) => {
      if (!appId || !envId || !userId) {
        throw new Error("Missing required parameters");
      }

      return api
        .patch<"/apps/:appId/envs/:envId/users/:userId/flags">(
          `/apps/${appId}/envs/${envId}/users/${encodeURIComponent(userId)}/flags`,
          variables,
        )
        .then((response) => response.data);
    },

    onSuccess: () => {
      if (appId && envId && userId) {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.flags(appId, envId, userId),
        });
      }
    },
  });
}
